// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"05f5ccb3","256":"c1ea8f80","268":"1f5ec275","396":"7d1463ab","409":"e8b37708","567":"aa5a76ff","591":"8d37c4f9","599":"846964c9","650":"c432048f","694":"b6c845e6","919":"41906a7c"}[chunkId] + ".chunk.js";
};